function initNewswalls() {
    document.querySelectorAll('.newswall').forEach(wall => {
        const button = wall.querySelector('.newswall_load_more');
        if (!button) return;

        const columns = [...wall.querySelectorAll('.news-column')];
        const mobile = wall.querySelector('.wrapper--mobile');
        const status = wall.querySelector('.newswall_status');
        const label = button.querySelector('.button_text');
        button.hidden = false;

        const refreshLayout = () => window.ScrollTrigger?.refresh();
        wall.addEventListener('load', event => {
            if (event.target.tagName === 'IMG') refreshLayout();
        }, true);

        button.addEventListener('click', async () => {
            if (button.disabled) return;
            button.disabled = true;
            label.textContent = 'Lädt …';
            status.textContent = '';
            wall.setAttribute('aria-busy', 'true');
            const previousCount = mobile.children.length;

            try {
                const response = await fetch(wall.dataset.newsUrl, {
                    method: 'POST',
                    body: new URLSearchParams({
                        action: 'kata_newswall_load_more',
                        page_id: wall.dataset.newsPageId,
                        module_index: wall.dataset.newsModule,
                        page: wall.dataset.newsNextPage,
                    }),
                });
                if (!response.ok) throw new Error('Request failed');
                const result = await response.json();
                if (!result.success) throw new Error('Loading failed');

                const data = result.data;
                columns.forEach((column, index) => column.insertAdjacentHTML('beforeend', data.columns[index]));
                mobile.insertAdjacentHTML('beforeend', data.mobile);
                wall.dataset.newsNextPage = String(data.next_page);
                button.hidden = !data.has_more;
                status.textContent = `${data.count} weitere News geladen.`;

                if (button.hidden && document.activeElement === button) {
                    [...wall.querySelectorAll(`[data-news-index="${previousCount}"]`)]
                        .find(item => item.getClientRects().length)?.focus({ preventScroll: true });
                }
                refreshLayout();
            } catch {
                status.textContent = 'Die News konnten nicht geladen werden. Bitte erneut versuchen.';
            } finally {
                button.disabled = false;
                label.textContent = 'Mehr Laden';
                wall.setAttribute('aria-busy', 'false');
            }
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewswalls, { once: true });
} else {
    initNewswalls();
}
